// extracted by mini-css-extract-plugin
module.exports = {"root":"IconClose_root__3XBb2"};